<template>
    <div class="thead bg-secondary">

        <template v-if="$mq === 'narrow'">
            <template v-for="value in storeResource.cate_title">
                <template v-if="value.lom_field.field.uri === 'hkepc:checkbox'">
                    <div v-show="storeResource.show_check_box">
                        <div id="mobile-resources-heading">
                            <div class="th selectbox">
                                <template v-if="storeResource.content_type === 'single'">
                                    <input type="checkbox" name="select_all_btn" id="head" value="option1"
                                        :checked="selectAllStatus ? 'checked' : false">
                                    <label class="pull-right text" for="head" @click="selectAll"><span
                                            class="text-secondary">{{ lang($t("Select All")) }}</span></label>
                                </template>
                                <template v-else>
                                    <input type="checkbox" name="select_all_btn" :id="'table_' + table_key"
                                        value="option1">
                                    <label class="pull-right text" :for="'table_' + table_key"
                                        @click="selectAllGroup(table_key)"><span class="text-secondary">{{
            lang($t("Select All")) }}</span></label>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </template>

        <template v-if="$mq === 'wide'">

            <div class="tr">
                <template v-for="(value, row_key) in storeResource.cate_title">
                    <!-- check fill space -->
                    <!--<template v-if="value.lom_field.field.uri === 'hkepc:general/description'">-->
                    <!--<div class="th" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">{{ value.display_name }}</div>-->
                    <!--</template>-->

                    <!-- checkbox column -->
                    <template v-if="value.lom_field.field.uri === 'hkepc:checkbox'">
                        <div class="th selectbox">
                            <div v-show="storeResource.show_check_box">
                                <template v-if="storeResource.content_type === 'single'">
                                    <input type="checkbox" name="select_all_btn" id="head" value="option1"
                                        :checked="selectAllStatus ? 'checked' : false">
                                    <label class="pull-right text" for="head" @click="selectAll"></label>
                                </template>
                                <template v-else>
                                    <input type="checkbox" name="select_all_btn" :id="'table_' + table_key"
                                        value="option1">
                                    <label class="pull-right text" :for="'table_' + table_key"
                                        @click="selectAllGroup(table_key)"></label>
                                </template>
                            </div>


                        </div>
                    </template>


                    <template v-else-if="value.lom_field.field.uri === 'hkepc:hkep-file'">
                        <div class="th download">
                            <p>{{ value.display_name }}</p>
                        </div>
                    </template>

                    <template v-else-if="value.lom_field.field.uri === 'hkepc:hkep-thumbnail'">
                        <div class="th thumbnail">
                            <p>{{ value.display_name }}</p>
                        </div>
                    </template>

                    <!-- content -->
                    <template v-else>
                        <!-- width - provide by backend -->
                        <div class="th" :style="styleHeading(value.display_config)">
                            <div class="table-head-sorting">
                                <p>{{ value.display_name }}</p>

                                <!-- sorting arrow -->
                                <template v-if="value.sorting === true">
                                    <div @click="sort(value.lom_field.field.uri, table_key, row_key)"
                                        :data-sort="value.field" class="bg-quaternary">
                                        <svg :id="'desc_' + table_key + '_' + row_key"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"
                                            style="display: none;">
                                            <path d="M0,22l40,40l40-40H0z"></path>
                                        </svg>

                                        <svg :id="'asc_' + table_key + '_' + row_key" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 80 80">
                                            <path d="M0,58l40-40l40,40H0z"></path>
                                        </svg>
                                    </div>
                                </template>

                            </div>

                        </div>
                    </template>

                </template>
            </div>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import { common } from '@mixins/common';
import { storeMapper } from '@mixins/storeMapper';
import EventBus from '@common/eventBus';
import {URI} from "../../config/uri";

export default {
    name: "SubCateListTableHeading",
    mixins: [common, storeMapper],
    props: [
        "table_key"
    ],
    data() {
        return {
            currentSort: "",
            currentSortOrder: "asc",
        }
    },
    mounted() {
        EventBus.$on("unselect_select_all_btn", this.unselect_all_btn)
        for (let i = 0; i < this.cateTitle.length; i++) {
            if (this.cateTitle[i].sorting && this.cateTitle[i].default_sorting !== "NONE") {
                this.currentSortOrder = this.cateTitle[i].default_sorting === 'ASC' ? 'desc' : 'asc'
                this.sort(this.cateTitle[i].lom_field.field.uri, this.table_key, i)
                return
            }
        }
    },
    computed: {
        selectAllStatus() {
            return this.storeResource.check_all_resource;
        },
        cateTitle() {
            return this.storeResource.cate_title
        }
    },
    methods: {
        unselect_all_btn() {
            document.getElementsByName("select_all_btn").forEach(function (obj) {
                obj.checked = false;
            });
        },
        styleHeading(config) {
            return {
                "width": (config === null) ? "auto" : config.width,
                "min-width": (config === null) ? "initial" : config.width,
            }
        },
        selectAll() {

            //toggle checkbox
            this.resourceIds = [];
            var resourceIds = this.resourceIds;
            if (!this.selectAllStatus) {

                this.$store.commit("resource_store/update_check_all_status", true);

                //clear all records
                this.storeResource.cate_list.forEach((item, index) => {
                    let size = this.isGoodNotesResource(item.content) ? 10 : item.size;
                    if (item.allow_download === true && item.allow_use === true && size > 0 && !item.is_filtered && !item.check) {
                        resourceIds.push(item.row);

                        //新增到resource store
                        this.$store.commit("resource_store/add", item);
                        Vue.set(item, 'check', true);
                    }

                });
                //this.$store.commit('cate/setLoaded', true);

            } else {

                this.storeResource.cate_list.forEach((item, index) => {
                    let size = this.isGoodNotesResource(item.content) ? 10 : item.size;
                    if (item.allow_download === true && item.allow_use === true && item.check && size > 0 && !item.is_filtered) {
                        Vue.set(item, 'check', false);
                        this.$store.commit("resource_store/remove", item);
                    }

                });

                this.$store.commit("resource_store/update_check_all_status", false);

            }
        },
        selectAllGroup(table_key) {
            //toggle checkbox
            this.resourceIds = [];
            var resourceIds = this.resourceIds;

            if (!this.storeResource.check_all_group_resource[table_key]) {

                this.$store.commit("resource_store/update_check_all_status", true);

                //clear all records
                this.storeResource.cate_list[table_key].resource.forEach((item, index) => {
                    let size = this.isGoodNotesResource(item.content) ? 10 : item.size;
                    if (item.allow_download === true && item.allow_use === true && size > 0 && !item.is_filtered && !item.check) {
                        resourceIds.push(item.row);

                        //新增到resource store
                        this.$store.commit("resource_store/add", item);
                        Vue.set(item, 'check', true);
                    }

                });
                this.storeResource.check_all_group_resource[table_key] = true;

            } else {

                this.storeResource.cate_list[table_key].resource.forEach((item, index) => {
                    let size = this.isGoodNotesResource(item.content) ? 10 : item.size;
                    if (item.allow_download === true && item.allow_use === true && item.check && size > 0 && !item.is_filtered) {
                        Vue.set(item, 'check', false);
                        this.$store.commit("resource_store/remove", item);
                    }

                });

                this.storeResource.check_all_group_resource[table_key] = false;

            }
        },
        isGoodNotesResource(obj) {
            return Array.isArray(obj) && obj.some(item => item.value === URI.OPEN_GOODNOTES);
        },
        sort(sort_value, key, sort_button_key) {

            this.currentSortOrder = (this.currentSortOrder === 'asc') ? 'desc' : 'asc';

            var button1 = document.getElementById("asc_" + key + "_" + sort_button_key);
            var button2 = document.getElementById("desc_" + key + "_" + sort_button_key);
            if (this.currentSortOrder === 'asc') {
                button1.style.display = "block";
                button2.style.display = "none";
            } else {
                button1.style.display = "none";
                button2.style.display = "block";
            }


            let _obj_a = "";
            let _obj_b = "";
            let compare = ((a, b) => {

                a.content.forEach(value => {
                    if (value.key === sort_value) {
                        _obj_a = value.value;
                    }
                });

                b.content.forEach(value => {
                    if (value.key === sort_value) {
                        _obj_b = value.value;
                    }
                });

                if (_obj_b !== null && _obj_a !== null) {
                    if (Number.isInteger(_obj_b) && Number.isInteger(_obj_a)) {
                        //sort by int
                        if (_obj_a < _obj_b) {
                            if (this.currentSortOrder === 'asc') {
                                return -1;
                            } else {
                                return 1;

                            }
                        }

                        if (_obj_a > _obj_b) {
                            if (this.currentSortOrder === 'asc') {
                                return 1;
                            } else {
                                return -1;

                            }
                        }
                    } else {
                        //if sort by string
                        if (this.currentSortOrder === 'asc') {
                            return _obj_a.localeCompare(_obj_b);
                        } else {
                            return _obj_b.localeCompare(_obj_a);
                        }
                    }
                }

                return 0;
            });

            if (key >= 0) {
                return this.storeResource.cate_list[key].resource.sort(compare);

            } else {
                return this.storeResource.cate_list.sort(compare);

            }

        }
    },
    watch: {
        cateTitle: {
            deep: true,
            handler(newVal) {
                for (let i = 0; i < newVal.length; i++) {
                    if (newVal[i].sorting && newVal[i].default_sorting !== "NONE") {
                        this.currentSortOrder = newVal[i].default_sorting === 'ASC' ? 'desc' : 'asc'
                        this.sort(newVal[i].lom_field.field.uri, this.table_key, i)
                        return
                    }
                }
            }
        }
    }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// resources/assets/js/components/SubCateListTableHeading.vue